import UnitPageShell from '../components/shared/UnitPageShell';
import React from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Paper, Typography, Box, Button } from '@mui/material';
import { useTheme } from '../contexts/ThemeContext';
import { getCardSx } from '../theme/tokens';
// importierte Extraktion aus Android (generiert via scripts/extract_android_units.js)
import extractedUnits from '../data/units_from_android.json';

// Saubere, korrigierte UNIT_CONTENT-Map mit extrahiertem Text für M1_U1
const UNIT_CONTENT: Record<string, Record<string, { title: string; text: string }>> = {
  M1: {
    M1_U1: {
      title: 'M1 U1 — Zuluftregelung',
      text:
        'Anlagenelemente: Be- und Entlüftungsanlage mit Erhitzer und Zu- und Abluftventilator sowie Außen- und Fortluftklappe.  ' +
        'Regelung: Konstante Zulufttemperatur-Regelung, Anfahrschaltung, Frostschutz (luft- und wasserseitig), Stillstandsregelung, Pumpenblockier-schutz.  ' +
        'Funktionsbeschreibung: Die Anlage wird durch Zeitprogramme eingeschaltet. Die Anfahrschaltung öffnet das Ventil (Y1) für den Lufterhitzer und schaltet die Umwälzpumpe P1 (K21) ein. Der Fühler (B7) erfaßt die Rücklauftemperatur des Heizmediums. Ist der Grenzwert für die Rücklauftemperatur erreicht, wird die Anlagenschaltung über (K17) freigegeben. Die Steuerung im Schaltschrank muß die Außen- und Fortluftklappe öffnen und den Zu- und Abluftventilator einschalten. Mit der Rückmeldung (K01) wird die Regelung freigegeben.  ' +
        'Die vom Fühler (B2) gemessene Zulufttemperatur wird mit dem Sollwert verglichen. Entsprechend der Regelabweichung wird der Lufterhitzer (Y1) angesteuert, bis der gewünschte Sollwert erreicht ist.  ' +
        'Der Frostschutzwächter (K9) schaltet bei Frostgefahr die Ventilatoren aus, schließt die Außen- und Fortluftklappen, öffnet das Ventil (Y1) für den Lufterhitzer und schaltet die Pumpe (P1) ein.  ' +
        'Bei ausgeschalteter Anlage wird ein Sollwert für die Stillstands-Regelung wirksam. Über Fühler (B7) und Regelventil (Y1) wird die eingestellte Mindesttemperatur als Einfriersicherung gehalten. Bei eingeschalteter Anlage wirkt der stetige Frostschutz. Der Fühler (B7) öffnet bereits oberhalb der eingestellten Frostschutztemperatur das Ventil (Y1) stetig.  ' +
        'Die Filterüberwachung erfolgt über den Differenzdruckwächter (K12). Eine Intervallschaltung (Pumpenblockierschutz) verhindert das Festsetzen der Pumpen bei Stillstand der Anlage. Die Ventilator-, Pumpen-, Frostschutz-, Keilriemen- und Klappensteuerungen sind im Schaltschrank vorzusehen.'
    },
    M1_U2: { title: 'M1 U2 — Anlagenkomponenten', text: 'Komponenten in Lüftungsanlagen: Ventilatoren, Filterstufen, Wärmerückgewinnung, Befeuchter/Entfeuchter und Sensorik.' },
    M1_U3: { title: 'M1 U3 — Sicherheit & Normen', text: 'Sicherheitsaspekte, Brandschutzklappen, Filterüberwachung, Hygiene und relevante Normen.' }
  },
  M2: {
    M2_U1: { title: 'M2 U1 — Wärmeerzeugung', text: 'Überblick Wärmeerzeugung: Gas-Kessel, BHKW, Wärmepumpen und Fernwärme. Themen: Wirkungsgrad, Regelstrategien, Warmwasserbereitung.' },
    M2_U2: { title: 'M2 U2 — Heizkreise', text: 'Heizkreise: Vor-/Rücklauf, Mischer, Pumpen, hydraulischer Abgleich und Regelung.' },
    M2_U3: { title: 'M2 U3 — Verbraucher', text: 'Platzhalter: Verbraucher, Fußbodenheizung, Radiatoren.' },
    M2_U4: { title: 'M2 U4 — Hydraulische Schaltungen', text: 'Platzhalter: Hydraulische Schaltungen und Mischerkreise.' },
    M2_U5: { title: 'M2 U5 — Wartung & Inbetriebnahme', text: 'Platzhalter: Wartung, Inbetriebnahme-Checklisten.' }
  },
  M3: {
    M3_U1: { title: 'M3 U1 — Grundlagen Kälte', text: 'Freie Kühlung und Kälteerzeugung — Ein Überblick.' },
    M3_U2: { title: 'M3 U2 — Verteilung', text: 'Kühlkreise und Verteilung: Aufbau und Regelung.' },
    M3_U3: { title: 'M3 U3 — Quiz & Statistik', text: 'Quiz-Sammlung und Highscore-Funktionen.' }
  },
  M4: {
    M4_U1: { title: 'M4 U1 — Temperaturregelung', text: 'Grundlagen der Raumregelung, Sensorik und Regelstrategien.' },
    M4_U2: { title: 'M4 U2 — Luftregelung', text: 'Adiabatische Funktionen, Regelmethoden und Einsatzszenarien.' },
    M4_U3: { title: 'M4 U3 — Beleuchtung & Präsenz', text: 'Platzhalter: Beleuchtungssteuerung.' },
    M4_U4: { title: 'M4 U4 — Erweiterte Regelstrategien', text: 'Platzhalter: Erweiterte Strategien und Energieoptimierung.' }
  },
  M5: {
    M5_U1: { title: 'M5 U1 — Bus-Systeme', text: 'Übersicht: BACnet, Modbus, M-Bus und KNX.' },
    M5_U2: { title: 'M5 U2 — Modbus', text: 'Platzhalter: Modbus Grundlagen.' },
    M5_U3: { title: 'M5 U3 — M-Bus', text: 'Platzhalter: M-Bus (Zählerkommunikation).' },
    M5_U4: { title: 'M5 U4 — KNX', text: 'Platzhalter: KNX Grundlagen.' },
    M5_U5: { title: 'M5 U5 — DALI', text: 'Platzhalter: DALI Beleuchtungssteuerung.' },
    M5_U6: { title: 'M5 U6 — SMI/ASI', text: 'Platzhalter: Sonstige Bussysteme.' },
    M5_U7: { title: 'M5 U7 — Erweiterungen', text: 'Platzhalter: Praxisbeispiele.' }
  },
  M6: {
    M6_U1: { title: 'M6 U1 — Geräte & Bauteile', text: 'Ventilatoren, Pumpen, Sensoren und Aktoren: Grundlagen und Einsatz.' },
    M6_U2: { title: 'M6 U2 — Pumpen', text: 'Platzhalter: Pumpentypen, Kennlinien und Regelung.' },
    M6_U3: { title: 'M6 U3 — Frequenzumrichter & Ventilatoren', text: 'Platzhalter: Frequenzumrichter und EC-Ventilatoren.' },
    M6_U4: { title: 'M6 U4 — Schaltschrank', text: 'Platzhalter: Schaltschrankaufbau und Schutzgeräte.' },
    M6_U5: { title: 'M6 U5 — Netzteile & Elektronik', text: 'Platzhalter: Netzteile und Absicherung.' },
    M6_U6: { title: 'M6 U6 — Sicherheit & Sensorik', text: 'Platzhalter: Sicherheitssensorik und Taupunktwächter.' },
    M6_U7: { title: 'M6 U7 — Mechanik & Montage', text: 'Platzhalter: Mechanische Komponenten und Wartung.' }
  },
  M7: { M7_U1: { title: 'M7 U1 — Gebäudeautomation', text: 'Platzhalter: Gebäudeautomation und Integrationskonzepte.' } },
  M8: { M8_U1: { title: 'M8 U1 — Energie & Effizienz', text: 'Platzhalter: Energieoptimierung und Effizienzmaßnahmen.' } },
  M9: { M9_U1: { title: 'M9 U1 — Mess- & Regeltechnik', text: 'Platzhalter: Messtechnik und Regelkreise.' } },
  M10: {
    M10_U1: { title: 'M10 U1 — Zusatzfunktionen', text: 'Platzhalter: Erweiterte Funktionen und Tools.' },
    M10_U2: { title: 'M10 U2 — Übungen & Beispiele', text: 'Platzhalter: Übungsfälle.' }
  },
  M98: {
    M98_U1: { title: 'M98 U1 — Hilfe / FAQ', text: 'Hilfe, FAQ und Support-Informationen.' },
    M98_U2: { title: 'M98 U2 — Vorschläge', text: 'Platzhalter: Nutzer-Vorschläge.' },
    M98_U3: { title: 'M98 U3 — Highscore', text: 'Platzhalter: Highscore-Ansicht.' },
    M98_U4: { title: 'M98 U4 — Telefonliste', text: 'Platzhalter: Kontaktliste.' }
  },
  M99: {
    M99_U1: { title: 'M99 U1 — Tools', text: 'Platzhalter: Werkzeuge und Diagnose.' },
    M99_U2: { title: 'M99 U2 — Taupunkt & Feuchte', text: 'Platzhalter: Taupunktberechnung.' },
    M99_U3: { title: 'M99 U3 — Volumenstromrechner', text: 'Platzhalter: Volumenstromberechnung.' },
    M99_U4: { title: 'M99 U4 — Temperaturen', text: 'Platzhalter: Temperatur-/Widerstandskennlinien passiver Fuehler.' },
    M99_U5: { title: 'M99 U5 — Kabelberechnung', text: 'Platzhalter: Kabeldimensionierung.' },
    M99_U6: { title: 'M99 U6 — Leistungsberechnung', text: 'Platzhalter: Leistungs- und Stromberechnung.' },
    M99_U7: { title: 'M99 U7 — Widerstand & Elektrik', text: 'Platzhalter: Elektrik-Grundlagen.' }
  }
};

const ModuleUnit: React.FC = () => {
  const { modId, unitId } = useParams<{ modId: string; unitId: string }>();
  const { darkMode } = useTheme();
  // prefer static UNIT_CONTENT, fall back to extracted Android texts (units_from_android.json)
  let content = null as { title: string; text: string } | null;
  if (modId && unitId) {
    if (UNIT_CONTENT[modId] && UNIT_CONTENT[modId][unitId]) {
      content = UNIT_CONTENT[modId][unitId];
    } else if ((extractedUnits as any) && (extractedUnits as any)[unitId]) {
      content = { title: unitId, text: (extractedUnits as any)[unitId] };
    }
  }

  if (!modId || !unitId) return React.createElement(Typography, null, 'Kein Modul/Unit angegeben');

  return React.createElement(UnitPageShell, { title: content ? content.title : `${modId} — ${unitId}` },
    React.createElement(Paper, { sx: { ...getCardSx(darkMode), p: 3 } },
      React.createElement(Typography, { variant: 'h5', gutterBottom: true }, content ? content.title : `${modId} — ${unitId}`),
      React.createElement(Typography, { variant: 'body1', sx: { mb: 2, whiteSpace: 'pre-line' } }, content ? content.text : 'Inhalt noch nicht implementiert.'),
      React.createElement(
        Box,
        { sx: { display: 'flex', gap: 1 } },
        React.createElement(
          Button,
          {
            variant: 'contained',
            onClick: async (e: any) => {
              e.preventDefault();
              const qs = await (await import('../services/quizService')).default.resolveQuizSetForUnit(unitId!);
              if (qs) window.location.href = '/quizzes/set/' + encodeURIComponent(qs) + '/play';
              else window.location.href = `/quizzes/${unitId}/play`;
            }
          },
          'Zum Quiz'
        ),
        React.createElement(RouterLink, { to: `/modules/${modId}`, style: { textDecoration: 'none' } }, React.createElement(Button, { variant: 'text' }, 'Zurück zum Modul'))
      )
    )
  );
};

export default ModuleUnit;
